"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorBanner = void 0;
var react_1 = __importDefault(require("react"));
var storm_ui_1 = require("@amzn/storm-ui");
var error_banner_styles_1 = require("./error_banner.styles");
var ErrorBanner = function (props) {
    var errorMessage = props.errorMessage, instructionMessage = props.instructionMessage;
    return (react_1.default.createElement(error_banner_styles_1.ContentContainer, null,
        react_1.default.createElement(storm_ui_1.Card, null,
            react_1.default.createElement(storm_ui_1.Text, { type: 'h2' }, errorMessage),
            react_1.default.createElement(error_banner_styles_1.CardBody, null,
                react_1.default.createElement(storm_ui_1.Text, null, instructionMessage)))));
};
exports.ErrorBanner = ErrorBanner;
